exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-personal-info-left{margin-top:-90px}.block-personal-info-left .card .card-content img{width:16px;height:16px;cursor:pointer}.block-personal-info-right{margin:-90px -15px}.block-activity{margin-top:-15px}.block-public{margin-top:-10px}.block-activity-mobile{display:none}@media (max-width:414px){.block-personal-info-left .card .card-content img{width:16px;height:16px}.block-personal-info-right{margin:-35px 0}.block-activity{display:none}.block-activity-mobile{display:block;margin-top:20px}.block-public{margin-top:-10px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d0321fa","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserProfile/index.vue
// module id = 1078
// module chunks = 0